import VatSelect from "components/DropDowns/VatSelect";
import { useEffect, useState } from "react";
import { Col, Form, Row, Tab } from "react-bootstrap";

import { useTranslation } from "react-i18next";

export default function PricelistPriceTab({ productId, id, handler, price, vatId, vats = [] }) {
  const {
    t,
  } = useTranslation();

  const [_price, _setPrice] = useState(price);
  const [_vatId, _setVatId] = useState(vatId);
  const [pricelistId, setPricelistId] = useState(id);

  const handleScroll = (e) => {
    e.target.blur();
  };

  const handlePrice = (e) => {
    const formatPrice = e.target.value ? parseFloat(e.target.value.replace(/,/g, ".")) : null;
    _setPrice(formatPrice);
    const data = {
      pricelistId: pricelistId,
      price: formatPrice,
      vatId: _vatId,
    };
    handler(data);
  };

  const handleVat = (vatId) => {
    _setVatId(vatId);

    const data = {
      pricelistId: pricelistId,
      price: _price,
      vatId: vatId,
    };
    handler(data);
  };

  return (
    <Tab.Pane eventKey={`pricelist-nav-item-${pricelistId}`}>
      <Row>
        <Col>
          <Form.Group>
            <label>{t("common.labels.price")}</label>
            <Form.Control
              key={`pricelist-price-${pricelistId}-${productId}`}
              placeholder={t("common.labels.price")}
              type="number"
              defaultValue={price}
              onChange={handlePrice}
              step={".01"}
              min="0"
              onWheel={handleScroll}
            ></Form.Control>
          </Form.Group>
        </Col>
        <Col>
          <VatSelect key={`pricelist-vat-${pricelistId}`} title={t("tables.headers.vat")} defaultValue={vatId} handler={handleVat} defaultVats={vats} />
        </Col>
      </Row>
    </Tab.Pane>
  );
}
